module.exports = __webpack_public_path__ + "img/BadRagaz_Quellenhof_1.jpg";